export default __webpack_public_path__ + "static/media/Armguards of the Atlantean.30c23420.jpg";